import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

import {getReportDefaultFields} from '../../../reports/report-constants';
import type {ReportURLParams} from '../../../reports/report-types';

import {EntityListContainer} from '../../entity-lists/entity-list-container';

import {audienceFieldFilterFunction} from './audience-field-filter-function';
import {AudienceMemberListProvider} from './audience-member-list-provider';
import {AudienceMemberStatusFilter} from './audience-member-status-filter';

type Props = {
    audienceId: string;
    audienceName: string;
    isWebFxAudience: boolean;
    unfilteredCount: number;
    filters: FilterObject[];
    search: string;
    selectedPage: number;
    selectedSortField: string;
    selectedFields: string[];
    urlParams: ReportURLParams<'contacts'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onRemoveAllFilters: () => void;
    hasPeopleListFooter: boolean;
};

export function AudienceMemberListContainer(props: Props) {
    return (
        <AudienceMemberListProvider>
            <EntityListContainer
                {...props}
                entityType='contacts'
                customEmptyStateComponent={
                    <EmptyStateSmall
                        title='This audience is currently empty'
                        subtitle='Once you add members, they’ll show up here'
                        icon={
                            <div style={{width: '75px'}}>
                                <Illustration
                                    src='magnifying-glass-empty-state'
                                    width='100%'
                                    height='100%'
                                />
                            </div>
                        }
                    />
                }
                graduatedFilters={
                    <AudienceMemberStatusFilter
                        audienceId={props.audienceId}
                        // Note, this is the prop, not the filtered filters.
                        // We want to reflect the "default" filter here
                        filters={props.filters}
                        onParamChange={props.onParamChange}
                        urlParams={props.urlParams}
                    />
                }
                fieldFilterFunction={audienceFieldFilterFunction}
                unfilteredCount={props.unfilteredCount}
                unfilteredCountThreshold={0}
                parentEntityId={props.audienceId}
                scrollContainerSelector='#audience-member-list'
                defaultFields={getReportDefaultFields('audienceMembership').split(',')}
                hideFooterExport={true}
            />
        </AudienceMemberListProvider>
    );
}
